export default __webpack_public_path__ + "static/media/collection.f8d0f14a.svg";